/** Append a figure anchor without changing the report's query grammar. */
export function figureHref(path: string, figure: string | null): string {
  return figure === null ? path : `${path}#figure=${encodeURIComponent(figure)}`
}

/** Append a table row anchor, which a table matches against its rows' `rowAnchor`. */
export function rowHref(path: string, row: string | null): string {
  return row === null ? path : `${path}#row=${encodeURIComponent(row)}`
}

function anchorValue(hash: string, prefix: string): string | null {
  if (!hash.startsWith(prefix)) return null
  try {
    const value = decodeURIComponent(hash.slice(prefix.length))
    return value === '' ? null : value
  } catch {
    return null
  }
}

/** Read a figure anchor; unrelated and malformed anchors have no target. */
export function figureFromHash(hash: string): string | null {
  return anchorValue(hash, '#figure=')
}

/** Read a table row anchor; unrelated and malformed anchors have no target. */
export function rowFromHash(hash: string): string | null {
  return anchorValue(hash, '#row=')
}

function normalize(label: string): string {
  return label.trim().replace(/\s+/g, ' ').toLowerCase()
}

/** Compare figure labels without case or differences in whitespace. */
export function sameFigure(a: string, b: string): boolean {
  return normalize(a) === normalize(b)
}
